export default __webpack_public_path__ + "static/media/card-active.36b1feba.svg";